export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0 || 0x6D2B79F5;
  }

  getState(): number {
    return this.state >>> 0;
  }

  restoreState(state: number): void {
    if (!Number.isInteger(state) || state < 0 || state > 0xFFFFFFFF)
      throw new Error('随机数状态必须是有效的 32 位无符号整数');
    this.state = state >>> 0;
  }

  next(): number {
    this.state |= 0;
    this.state = this.state + 0x6D2B79F5 | 0;
    let value = Math.imul(this.state ^ this.state >>> 15, 1 | this.state);
    value = value + Math.imul(value ^ value >>> 7, 61 | value) ^ value;
    return ((value ^ value >>> 14) >>> 0) / 4294967296;
  }

  exponential(rate: number): number {
    if (!Number.isFinite(rate) || rate <= 0)
      throw new Error('指数分布参数必须大于 0');
    return -Math.log(Math.max(Number.EPSILON, 1 - this.next())) / rate;
  }
}
